module.exports = __webpack_public_path__ + "static/media/Sharp-LS014B7DD01-Mechanical-Drawing.cfb0cc02.jpg";